import React from "react";
import styles from "./Serving.module.css";
import { Container } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const Serving = () => {
  const userInfo = [
    {
      id: 1,
      Head: "Government Projects",
      Desc: "Leading large-scale initiatives with precision.",
      Image: "/images/Product/working.png",
      Title: "Aluminium, steel, copper, chrome, gold, and diamonds.",
      Title1: "Coal For energy generation and turbines.",
      Title2: "Crude oil, cooking oil, and natural gas solutions.",
    },
    {
      id: 2,
      Head: "Immigration and Consultancy",
      Desc: "Facilitating global opportunities.",
      Image: "/images/Product/meet.png",
      Title: "Solar energy systems (rooftop and large-scale).",
      Title1: "Hydrogen energy for innovative applications.",
    },
    {
      id: 3,
      Head: "Technology Transfer",
      Desc: "Bringing the latest innovations to your doorstep.",
      Image: "/images/Product/data.png",
      Title: "Biometric devices.",
      Title1: "CCTV surveillance systems.",
      Title2: "Healthcare monitoring equipment.",
    },
  ];
  return (
    <React.Fragment>
      <Container>
        <div className={styles.mainSection}>
          <Heading>Service Offerings</Heading>
          <Paragraph>
            Our tailored services streamline processes, connect industries, and{" "}
            <br /> drive success.
          </Paragraph>
        </div>

        <div className={styles.userGrid}>
          {userInfo.map((user) => (
            <div key={user.id} className={styles.userCard}>
              <div className={styles.imageWrapper}>
                <img
                  loading="lazy"
                  src={user.Image}
                  alt={user.name}
                  className={styles.userImage}
                />
                <div className={styles.overlay}>
                  <h3>{user.Head}</h3>
                  <p>{user.Desc}</p>
                </div>
              </div>

              <ul>
                {user.Title && <li>{user.Title}</li>}
                {user.Title1 && <li>{user.Title1}</li>}
                {user.Title2 && <li>{user.Title2}</li>}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Serving;
